import { observer } from 'mobx-react-lite';

export const ShowPersona = observer(() => {
  return null;
});
